import XLSX from 'xlsx';

export default function exportToSheet(
  dataJSON: any[],
  nomeArquivo: string,
  cabecalhoOrdenado = true,
  colunasMoeda: string[] = [],
  colunasSubtotal: string[] = [],
): void {
  const fileName = `${nomeArquivo}_${new Intl.DateTimeFormat('pt-BR').format(
    new Date(),
  )}.xlsx`;

  let ws: XLSX.WorkSheet;

  const usarSubtotal = colunasSubtotal.length > 0 && dataJSON.length > 0;

  if (usarSubtotal) {
    const colunas = Object.keys(dataJSON[0]);

    // Linha 1: totais
    const linhaSubtotal = colunas.map(coluna => {
      if (colunasSubtotal.includes(coluna)) {
        const colunaIndex = colunas.indexOf(coluna);

        return {
          f: `SUBTOTAL(9,${XLSX.utils.encode_col(
            colunaIndex,
          )}3:${XLSX.utils.encode_col(colunaIndex)}${dataJSON.length + 2})`,
        };
      }

      return null;
    });

    // Linha 2: cabeçalho
    const wsSubtotal = XLSX.utils.aoa_to_sheet([linhaSubtotal, colunas]);

    // Linha 3 em diante: dados
    XLSX.utils.sheet_add_json(wsSubtotal, dataJSON, {
      origin: 'A3',
      skipHeader: true,
    });

    ws = wsSubtotal;
  } else {
    // Comportamento original
    ws = XLSX.utils.json_to_sheet(dataJSON);
  }

  if (cabecalhoOrdenado && ws['!ref']) {
    const range = XLSX.utils.decode_range(ws['!ref']);

    if (usarSubtotal) {
      // Cabeçalho está na linha 2
      ws['!autofilter'] = {
        ref: XLSX.utils.encode_range({
          s: {
            r: 1,
            c: range.s.c,
          },
          e: {
            r: range.e.r,
            c: range.e.c,
          },
        }),
      };
    } else {
      ws['!autofilter'] = {
        ref: ws['!ref'],
      };
    }
  }

  const range = ws['!ref'] ? XLSX.utils.decode_range(ws['!ref']) : null;

  if (range && dataJSON.length > 0) {
    const colunas = Object.keys(dataJSON[0]);
    const colunasPlanilha = ws['!cols'] ?? [];

    ws['!cols'] = colunasPlanilha;

    colunasMoeda.forEach(coluna => {
      const colunaIndex = colunas.indexOf(coluna);

      if (colunaIndex === -1) {
        return;
      }

      let maiorLargura = coluna.length;

      // Formata o SUBTOTAL da linha 1 como moeda
      if (usarSubtotal) {
        const cellAddress = XLSX.utils.encode_cell({
          r: 0,
          c: colunaIndex,
        });

        const cell = ws[cellAddress];

        if (cell) {
          cell.z = 'R$ #,##0.00';
        }
      }

      const primeiraLinhaDados = usarSubtotal ? 2 : range.s.r + 1;

      // eslint-disable-next-line no-plusplus
      for (let row = primeiraLinhaDados; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({
          r: row,
          c: colunaIndex,
        });

        const cell = ws[cellAddress];

        if (cell && typeof cell.v === 'number') {
          cell.z = 'R$ #,##0.00';

          const valorFormatado = `R$ ${cell.v.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;

          maiorLargura = Math.max(maiorLargura, valorFormatado.length);
        }
      }

      colunasPlanilha[colunaIndex] = {
        wch: maiorLargura + 2,
      };
    });
  }

  const wb: XLSX.WorkBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, nomeArquivo.substring(0, 31));

  XLSX.writeFile(wb, fileName);
}
